/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowFigureACircleDownIcon16Light } from './ArrowFigureACircleDownIcon16Light';
import { ArrowFigureACircleDownIcon16Regular } from './ArrowFigureACircleDownIcon16Regular';
import { ArrowFigureACircleDownIcon16Solid } from './ArrowFigureACircleDownIcon16Solid';
import { ArrowFigureACircleDownIcon20Light } from './ArrowFigureACircleDownIcon20Light';
import { ArrowFigureACircleDownIcon20Regular } from './ArrowFigureACircleDownIcon20Regular';
import { ArrowFigureACircleDownIcon20Solid } from './ArrowFigureACircleDownIcon20Solid';
import { ArrowFigureACircleDownIcon24Regular } from './ArrowFigureACircleDownIcon24Regular';
import { ArrowFigureACircleDownIcon24Solid } from './ArrowFigureACircleDownIcon24Solid';
import { ArrowFigureACircleDownIcon32Regular } from './ArrowFigureACircleDownIcon32Regular';
import { ArrowFigureACircleDownIcon64Regular } from './ArrowFigureACircleDownIcon64Regular';
var sizes = {
    16: {
        light: ArrowFigureACircleDownIcon16Light,
        regular: ArrowFigureACircleDownIcon16Regular,
        solid: ArrowFigureACircleDownIcon16Solid,
    },
    20: {
        light: ArrowFigureACircleDownIcon20Light,
        regular: ArrowFigureACircleDownIcon20Regular,
        solid: ArrowFigureACircleDownIcon20Solid,
    },
    24: {
        regular: ArrowFigureACircleDownIcon24Regular,
        solid: ArrowFigureACircleDownIcon24Solid,
    },
    32: {
        regular: ArrowFigureACircleDownIcon32Regular,
    },
    64: {
        regular: ArrowFigureACircleDownIcon64Regular,
    },
};
export var ArrowFigureACircleDownIcon = forwardRef('ArrowFigureACircleDownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
